// Instellingen die het dashboard aansturen. Hier aanpassen, niet verspreid door de code.

// Het dashboard is getekend voor een 1920x1080 scherm en wordt naar het echte scherm geschaald.
export const designWidth = 1920;
export const designHeight = 1080;

// Kolom 2 wisselt af tussen het podium en de rest van de ranglijst.
export const podiumViewMs = 30000;
export const restViewMs = 10000;

// Lijst "Verkochte diensten": ruimte tussen de rijen en hoe snel hij doorrolt als hij te lang is.
export const rowGapMin = 18; // px
export const rowGapMax = 40; // px
export const marqueeSpeed = 32; // px per seconde

// Ophalen van data.
export const cacheMs = 300000; // 5 minuten hergebruiken voor we opnieuw ophalen
export const retryMs = 20000; // na een mislukte poging zo lang wachten
export const tokenCheckMs = 30000; // controleer of de gebruiker nog ingelogd is
export const monthCheckMs = 60000; // controleer of de maand is omgeslagen
export const clockTickMs = 60000;

// Muisaanwijzer verbergen als er zo lang niets beweegt. Zie hooks/useIdleCursor.js.
export const idleCursorMs = 30000;

// Animaties bij nieuwe verkopen.
export const refreshMs = 60000; // hoe vaak we kijken of er iets is bijgekomen
export const coinRainAmount = 500; // vanaf dit bedrag regent het munten
export const bigDealAmount = 1000; // vanaf dit bedrag gaat ook het grove geschut aan (diamantregen)
// Onder dit bedrag maken we geen feest van een record: anders staat er
// vuurwerk voor een verkoop van tien euro die toevallig de eerste was.
export const recordMinAmount = 500;

// Toetsen 1..9/0 spelen op het echte dashboard een animatie af, zodat je ze
// op de tv kunt uitproberen. Uit: op de tv hoort niemand met een toets
// vuurwerk te kunnen starten. Testen doe je in het animatielab, dat je met
// de verborgen code bereikt.
export const testShortcuts = false;
